import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
const HINT = "yoyo_admin";

async function fetchMe() {
  try {
    return (await api.get("/auth/me")).data;
  } catch (e) {
    await api.post("/auth/refresh");
    return (await api.get("/auth/me")).data;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem("yoyo_token");
    if (!localStorage.getItem(HINT)) {
      setUser(false);
      setLoading(false);
      return;
    }
    fetchMe()
      .then(setUser)
      .catch(() => {
        localStorage.removeItem(HINT);
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(HINT, "1");
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(HINT);
    setUser(false);
    api.post("/auth/logout").catch(() => {});
  }, []);

  const value = useMemo(() => ({ user, loading, login, logout }), [user, loading, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
